import {
  magicLinkClient,
  inferAdditionalFields,
  lastLoginMethodClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

import type { auth } from "./server";
import type { AuthClientOptions } from "./types";

const defaultPlugins = [
  magicLinkClient(),
  lastLoginMethodClient(),
  inferAdditionalFields<typeof auth>(),
];

const baseAuthClient = createAuthClient({
  plugins: defaultPlugins,
});

export type AuthClient = typeof baseAuthClient;

export const createClient = (options?: AuthClientOptions): AuthClient =>
  createAuthClient({
    ...options,
    plugins: [...(options?.plugins ?? []), ...defaultPlugins],
  }) as unknown as AuthClient;
